import { FunctionComponent } from 'react'
import { WChip } from '@alice-health/wonderland-react'
import { useDrawer } from '@/global/hooks'
import { MOBILE_FILTERS_PANEL_ID } from '@/modules/accredited-establishments/components/Filters'

interface FiltersButtonProps {
  /** Drops the label, leaving the icon alone */
  collapsed?: boolean
  /** How many panel filters are applied */
  count?: number
}

/**
 * Sticks to the left edge of the chip row, which scrolls behind it. The label
 * gives way to the icon once the row scrolls, and to the count once a filter
 * is applied.
 */
const FiltersButton: FunctionComponent<FiltersButtonProps> = ({
  collapsed = false,
  count = 0
}) => {
  const { open } = useDrawer(MOBILE_FILTERS_PANEL_ID)

  const hasCount = count > 0

  return (
    <div className='sticky left-0 shrink-0 bg-gl-color-shades-white pr-gl-spacing-03'>
      {/* `WChip` keeps its first render when these props change: remount it. */}
      <WChip
        key={`${hasCount ? count : 'no-filter'}-${collapsed}`}
        label={collapsed || hasCount ? '' : 'Filtros'}
        leadingIcon='icMenuFilter'
        // Without a label the counter only shows while active.
        active={hasCount}
        counter={hasCount ? String(count) : ''}
        onWClick={open}
      />
    </div>
  )
}

export { FiltersButton }
export type { FiltersButtonProps }
